import * as React from 'react';
import { Tabs, TabsTabProps } from '@mantine/core';
import { createLink, LinkComponent } from '@tanstack/react-router';
import classes from './Tab.module.css';

const MantineLinkComponent = React.forwardRef<HTMLButtonElement, TabsTabProps>(
  (props, ref) => {
    return <Tabs.Tab component="a" ref={ref} {...props} />;
  }
);

MantineLinkComponent.displayName = 'MantineLinkComponent';

const CreatedLinkComponent = createLink(MantineLinkComponent);

export const Tab: LinkComponent<typeof MantineLinkComponent> = (props) => {
  return (
    <CreatedLinkComponent className={classes.tabsLabel} py="md" {...props} />
  );
};
